module.exports = __webpack_public_path__ + "img/ka2-1.f82d7dbf.png";